/* eslint-disable import/no-cycle */
import React, { Component } from 'react';
import _ from 'lodash';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import MuiGrid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
  TableFooter,
  TablePagination
} from '@material-ui/core';
import moment from 'moment';
import DatePicker, { registerLocale } from 'react-datepicker';
import fr from 'date-fns/locale/fr';
import {
  handleNewSepcialHour,
  handleRemoveSubmitSpecialHour,
  handleChangeSpecificHours,
  setSpecialHour,
  handleChangePage,
  handleChangeRowsPerPage,
  handleChangeExpend,
  handleAddSepcificHour,
  handleRemoveSpecificHours,
  handleClose,
  setStartDate
} from './SpecialHoursConfig.services';
import { styles } from './SpecialHoursConfig.styles';
import { mainColor, settings } from '../../constants';
import 'rc-time-picker/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import { Modal, Button, Switch, Input, Paper, IconButton, BackButton } from '..';
import * as actions from '../../actions/index';
import { checkAccess } from '../../utils/admins';

registerLocale('fr', fr);

const Grid = withStyles(() => ({}))(MuiGrid);

const CustomDayPickerInput = ({ value, onClick }) => {
  return (
    <Button
      outlined
      style={{ borderWidth: 2, fontWeight: 'bolder' }}
      type='button'
      className='datepicker-input'
      onClick={onClick}
    >
      {value}
    </Button>
  );
};
const INITIAL_STATE = {
  pageHours: 0,
  rowsPerPageHours: 5,
  checkBoxSpecificHour: false,
  specialHour: {},
  modalSpecialHours: false,
  checkBoxRecurrEvent: false,
  specialHourToRemove: null,
  expanded: {},
  slotErrorMessages: {}
};
class SpecialHourConfig extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  renderSpecialHours = () => {
    const { configurations, classes } = this.props;
    const { pageHours, rowsPerPageHours } = this.state;
    const { specialHours = {} } = configurations;
    const renderSpecialHours = _.orderBy(
      _.map(specialHours, (hour, key) => {
        return {
          ...hour,
          key,
          date: hour.day.length < 6 ? `${moment().year()}-${hour.day}` : hour.day
        };
      }),
      ['date']
    )
      .reverse()
      .slice(pageHours * rowsPerPageHours, pageHours * rowsPerPageHours + rowsPerPageHours);
    return (
      <TableBody>
        {renderSpecialHours.map((e, i) => {
          const { day = '', slots, key } = e;
          return (
            <TableRow
              expanded={this.state.expanded[key]}
              onChange={() => handleChangeExpend(i, this)}
              square
              className={classes.tableRow}
              key={key}
            >
              <TableCell align='center' className={classes.specialHour}>
                {day.length > 6 ? '' : 'Tous les '}
                {moment(day)
                  .locale('fr')
                  .format(`${day.length > 6 ? 'DD MMMM YYYY' : 'DD MMMM'}`)}
              </TableCell>
              <TableCell align='center' className={classes.specialHour}>
                {slots
                  ? slots.map(slot => (
                    <div key={slot}>
                      <p align='center' className={classes.pos}>
                        {slot}
                      </p>
                    </div>
                  ))
                  : 'fermé'}
              </TableCell>
              <TableCell align='center' className={classes.specialHour}>
                {day && day.length > 6 ? 'Unique' : 'Annuelle'}
              </TableCell>
              <TableCell align='center' className={classes.buttonSize}>
                <IconButton
                  title='Supprimer la date'
                  label='Delete'
                  className={classes.icon}
                  onClick={() => {
                    this.setState({ specialHourToRemove: key });
                    const { showModal } = this.props;
                    const modalData = {
                      color: 'danger',
                      title: 'Suppression des horaires',
                      message: 'Êtes-vous sûr(e) de vouloir supprimer ces horaires spécifiques ?',
                      showCancelBtn: true,
                      btnColor: 'danger',
                      onClick: () => {
                        handleRemoveSubmitSpecialHour(this);
                        showModal(null);
                      },
                      btnTxt: 'Supprimer'
                    };
                    showModal(modalData);
                  }}
                  disabled={!checkAccess('features', 'specificHours')}
                >
                  <DeleteOutlinedIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  };

  renderConfigSpecificHour = () => {
    const { classes } = this.props;
    const { checkBoxSpecificHour, specialHour = {}, checkBoxRecurrEvent } = this.state;
    const { slots = [] } = specialHour;
    const returnComponents = [];
    returnComponents.push(
      <Paper className={classes.contentStyle}>
        <DatePicker
          withPortal
          dateFormat='dd MMMM yyyy'
          selected={specialHour.day}
          customInput={<CustomDayPickerInput />}
          onSelect={date => setStartDate(date, this)}
          minDate={moment().toDate()}
          locale='fr'
        />
        <div className='row my-3 mr-2  justify-content-center align-items-center'>
          <Switch
            onChange={() => this.setState({ checkBoxRecurrEvent: !checkBoxRecurrEvent })}
            checked={checkBoxRecurrEvent}
          />
          <div className={classes.textStyle}>Récurrence Annuelle</div>
        </div>
        <div className='row mx-0 px-0 w-100  justify-content-center align-items-center'>
          <div className='col-sm-5 px-0 mx-0  d-flex justify-content-center align-items-center'>
            <Switch
              onChange={() => this.setState({ checkBoxSpecificHour: !checkBoxSpecificHour })}
              checked={checkBoxSpecificHour}
            />
            <div className={classes.textStyle}>Fermer toute la journée</div>
          </div>
          <div className='col-sm-2 d-flex flex-column justify-content-center align-items-center mb-3 mb-sm-0'>
            <div className={classes.choiceText}>(ou)</div>
          </div>
          <div className='col-sm-5 d-flex flex-column justify-content-center align-items-center'>
            <div
              className={classes.textStyle}
              style={{
                color: checkBoxSpecificHour ? mainColor.colorClearGray : mainColor.colorBlack
              }}
            >
              Ajouter un créneau horaire :
            </div>
            <IconButton
              label='Add'
              className={classes.iconStyle}
              disabled={checkBoxSpecificHour}
              onClick={() => handleAddSepcificHour(this)}
              style={{
                color: mainColor.colorWhite,
                backgroundColor: checkBoxSpecificHour
                  ? mainColor.colorClearGray
                  : `rgba(${mainColor.rgb}, 0.8)`
              }}
            >
              <AddIcon className={classes.addIcon} />
            </IconButton>
            {slots &&
              !checkBoxSpecificHour &&
              slots.map((f, j) => {
                const errorMessage = this.state.slotErrorMessages[j]
                return (
                  <div key={f} className='row d-flex justify-content-center align-items-center'>
                    <Input
                      type='time'
                      value={f.start}
                      onChange={event =>
                        handleChangeSpecificHours(j, event.target.value, 'start', this)
                      }
                      InputLabelProps={{
                        shrink: true
                      }}
                      error={errorMessage}
                    />

                    <div className={classes.textField}> à </div>

                    <Input
                      type='time'
                      value={f.end}
                      onChange={event =>
                        handleChangeSpecificHours(j, event.target.value, 'end', this)
                      }
                      InputLabelProps={{
                        shrink: true
                      }}
                      error={errorMessage}
                    />
                    <div className='d-flex'>
                      <IconButton
                        label='Remove'
                        className={classes.icon}
                        onClick={() => handleRemoveSpecificHours(j, this)}
                        style={{ alignSelf: 'flex-end' }}
                        disabled={slots.length === 1}
                      >
                        <DeleteOutlinedIcon className={classes.removeButton} />
                      </IconButton>
                    </div>
                    <div className={errorMessage ? `${classes.errorMessage}` : ''}>{errorMessage}</div>
                  </div>
                )
              })}
          </div>
        </div>
      </Paper>
    );
    return returnComponents;
  };

  render() {
    const { classes, configurations, history, sidebarCollapse } = this.props;
    const { rowsPerPageHours, modalSpecialHours, pageHours } = this.state;
    const { specialHours = {} } = configurations;
    return (
      <div className={`col-12 p-4 ${sidebarCollapse && 'col-lg-10'} px-0`}>
        <div className='row ml-0 mr-0 align-items-center'>
          <BackButton
            className='d-flex col-12 col-md-9 col-xl-9 pl-0'
            onClick={() => history.goBack()}
            title={settings.specificHours.text}
            subtitle={settings.specificHours.description}
          />
          <Button
            className='col-12 col-md-3 col-xl-3'
            padding='sm'
            color='secondary'
            outlined
            onClick={() => setSpecialHour(this)}
            disabled={!checkAccess('features', 'specificHours')}
          >
            <div className='row justify-content-center align-items-center mr-0 ml-0'>
              <AddIcon style={{ marginRight: '6px' }} />
              Horaires spécifiques
            </div>
          </Button>
        </div>
        <div>
          <Grid item md={12}>
            <Paper className={classes.root} style={{ overflowX: 'auto' }}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell align='center' className={classes.heading}>
                      Date
                    </TableCell>
                    <TableCell align='center' className={classes.heading}>
                      Horaires
                    </TableCell>
                    <TableCell align='center' className={classes.heading}>
                      Récurrence de l'événement
                    </TableCell>
                    <TableCell align='center' className={classes.heading} />
                  </TableRow>
                </TableHead>
                {this.renderSpecialHours()}
                <TableFooter>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 20]}
                    count={_.keys(specialHours).length}
                    rowsPerPage={rowsPerPageHours}
                    page={pageHours}
                    labelRowsPerPage='Lignes par page'
                    backIconButtonProps={{
                      'aria-label': 'Previous Page'
                    }}
                    nextIconButtonProps={{
                      'aria-label': 'Next Page'
                    }}
                    onChangePage={(event, page) => handleChangePage(event, page, 'pageHours', this)}
                    onChangeRowsPerPage={e => handleChangeRowsPerPage(e, 'rowsPerPageHours', this)}
                  />
                </TableFooter>
              </Table>
            </Paper>
          </Grid>
        </div>

        <Modal
          isOpen={modalSpecialHours}
          color='secondary'
          title='Nouvelle horaire spécifique'
          header
          width='700px'
          size='lg'
          handleClose={() => handleClose(this)}
          showCancelBtn
          onClick={() => handleNewSepcialHour(this)}
          fixed
          modalBodyStyle={{ backgroundColor: 'rgba(200, 200, 200, 0.3)' }}
          btnTxt='Enregistrer'
        >
          {this.renderConfigSpecificHour()}
        </Modal>
      </div>
    );
  }
}

function mapStateToProps({ firebaseRealTime, sidebar }) {
  const { shop } = firebaseRealTime;
  const { sidebarCollapse } = sidebar;

  return {
    configurations: shop,
    sidebarCollapse
  };
}
SpecialHourConfig.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(SpecialHourConfig)));
